export default function ({ store, redirect, route }) {
  // automatic redirect
  const { language } = store.getters
  let newPath = '/'
  switch (language) {
    case 'de':
      newPath = '/unternehmen/events'
      break
    case 'en':
      newPath = '/company/events'
      break
    default:
      newPath = '/'
  }
  if (route.params && route.params.eventname) {
    switch (route.params.eventname) {
      case 'cdp-event':
        newPath = '/unternehmen/events/cdp-event/munich/2024/03'
    }
  }
  return redirect(newPath)
}
